import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Stack from '@mui/system/Stack';
import type { LoginMethodType } from './LoginMethods';
import { LoginOption } from './LoginOption';

type LoginStackProps = {
  signInFn: (loginMethodType: LoginMethodType) => void;
  topOptions?: LoginMethodType[];
  bottomOptions?: LoginMethodType[];
};

export function LoginStack({
  signInFn,
  topOptions = ['discord', 'twitter', 'google', 'phone', 'email'],
  bottomOptions = ['wallet'],
}: LoginStackProps) {
  return (
    <Stack spacing={'16px'}>
      {topOptions.map((loginMethodType, index) => (
        <LoginOption
          loginMethodType={loginMethodType}
          key={index}
          signInFn={signInFn}
        />
      ))}
      {topOptions.length > 0 && bottomOptions.length > 0 && (
        <Box>
          <Typography
            textTransform={'uppercase'}
            mt={'0!important'}
            textAlign={'center'}
          >
            Or
          </Typography>
        </Box>
      )}
      {bottomOptions.map((loginMethodType, index) => (
        <LoginOption
          loginMethodType={loginMethodType}
          key={topOptions.length + index}
          signInFn={signInFn}
        />
      ))}
    </Stack>
  );
}
